import classNames from 'classnames';

import './page.css';

type PageProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  contentType?: 'extra-light' | 'light' | 'heavy' | 'max' | 'fluid';
  as?: React.ElementType;
};

/**
 * This component is to be used when padding on the left, top, right and bottom sides of
 * the content is needed, which is dependent on breakpoints of the screen size. These paddings
 * will differ based on the `contentType` prop. This means for example overriding the style
 * prop with `padding: 0` should never occur.
 * For content that should take the full width and height of the screen without padding, use a
 * regular `div` instead.
 */
const Page = ({ children, className, style, contentType = 'light', as, ...restProps }: PageProps) => {
  const classes = classNames(
    `page-content`,
    {
      'page-extra-light': contentType === 'extra-light',
      'page-light': contentType === 'light',
      'page-heavy': contentType === 'heavy',
      'page-max': contentType === 'max',
      'page-fluid': contentType === 'fluid',
    },
    className,
  );

  const Component = as ?? 'main';

  return (
    <Component className={classes} style={style} {...restProps}>
      {children}
    </Component>
  );
};

export default Page;
